import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'api/axios'

import dayjs from 'dayjs'

const initialState = {
  loading: false,
  error: '',
  disponibles: [],
  seleccionada: {},
  loadingCampos: false,
  errorCampos: '',
  loadingInicializacion: false,
  errorInicializacion: '',
  campos: [],
  estructura: [],
  datos: [],
  descripciones: [],
  datos_iniciales: [],
  descripciones_iniciales: [],
  html: null,
  modo: null,
  vacaciones: {
    pendientes: null,
    tipo_dias: null,
    disfruta_horas: null,
  },
}

//recupera lista de solicitudes
export const fetchListaSolicitudes = createAsyncThunk('/listasolicitudes', async () => {
  const response = await axios.get('/listasolicitudes/')
  return response.data
})

//recupera lista de solicitudes
export const fetchCamposSolicitudes = createAsyncThunk(
  '/campossolicitudes',
  async ({ tipo, subtipo }) => {
    const response = await axios.get(`/campossolicitudes/${tipo}/${subtipo}/`)
    return response.data
  },
  {
    condition: (_, { getState }) => {
      const { solicitudes } = getState()
      if (solicitudes.loadingCampos === true) {
        return false
      }
    },
  },
)

//ejecutar las consultas iniciales (legacy - mantener por compatibilidad)
export const consultaInicial = createAsyncThunk(
  '/consultainicial',
  async ({ idpk, valores }) => {
    const response = await axios.post(`/consultainicial/${idpk}/`, { valores })
    return response.data
  },
  {
    condition: ({ idpk }, { getState }) => {
      const { solicitudes } = getState()
      const campo = solicitudes.campos.filter((c) => Number(c.idpk) === Number(idpk))[0]
      if (campo.cargando === true) {
        return false
      }
      if (campo.inicializando !== 'P') {
        return false
      }
    },
  },
)

//inicializa todos los campos de una solicitud en una sola llamada
export const inicializaSolicitud = createAsyncThunk(
  '/inicializasolicitud',
  async ({ tipo, subtipo }) => {
    const response = await axios.post('/inicializasolicitud/', { tipo, subtipo })
    return response.data
  },
  {
    condition: (_, { getState }) => {
      const { solicitudes } = getState()
      if (solicitudes.loadingInicializacion === true) {
        return false
      }
    },
  },
)

export const solicitudesSlice = createSlice({
  name: 'solicitudes',
  initialState,
  reducers: {
    setDatosVacaciones: (state, action) => {
      state.vacaciones = action.payload
    },
    setSolicitudSeleccionada: (state, action) => {
      state.seleccionada = action.payload
    },
    setDatoSolicitud: (state, action) => {
      const { idpk, valor, descripcion } = action.payload

      state.datos[idpk] = valor
      state.descripciones[idpk] = descripcion

      // Borramos los campos dependientes de este
      const campo = state.campos.filter((c) => Number(c.idpk) === Number(idpk))[0]

      if (campo?.cmp_dependientes && campo.inicializando !== 'R') {
        campo.cmp_dependientes
          .replace(/:/gm, '')
          .split(',')
          .forEach((codigo_campo) => {
            const dependiente = state.campos.filter((c) => c.codigo_campo === codigo_campo)[0]

            if (dependiente.inicializando !== 'R') {
              state.datos[dependiente.idpk] = null
              state.descripciones[dependiente.idpk] = null
            }
          })
      }

      // Re-lanzar consultaInicial para campos que referencian al campo modificado
      if (campo && campo.inicializando !== 'R') {
        state.campos.forEach((c) => {
          if (
            c.depende_de &&
            c.depende_de.includes(campo.codigo_campo) &&
            c.inicializando !== 'R' &&
            c.inicializando !== 'P'
          ) {
            c.inicializando = 'P'
          }
        })
      }

      // Re-lanzar consultalov para campos cuya LOV referencia al campo modificado
      if (campo && campo.inicializando !== 'R') {
        state.campos.forEach((c) => {
          if (c.lv_depende_de && c.lv_depende_de.includes(campo.codigo_campo)) {
            c.lovVersion = (c.lovVersion || 0) + 1
          }
        })
      }
    },
    setDatosSolicitud: (state, action) => {
      state.datos = action.payload
    },
    loadDatosEditando: (state, action) => {
      const datos = action.payload.datos
      for (let i = 0; i < datos.length; i++) {
        const campo = state.campos.filter(
          (c) =>
            c.codigo_campo === datos[i].codigo_campo &&
            c.codigo_plantilla === datos[i].codigo_plantilla,
        )[0]
        if (campo?.tipo_dato === 'V') {
          state.datos[campo.idpk] = datos[i].valor_alfa
        } else if (campo?.tipo_dato === 'N') {
          state.datos[campo.idpk] = datos[i].valor_number
        } else if (
          campo?.tipo_dato === 'D' ||
          campo?.tipo_dato === 'DH1' ||
          campo?.tipo_dato === 'DH2'
        ) {
          state.datos[campo.idpk] = datos[i].valor_date ? dayjs(datos[i].valor_date) : null
        }
      }
    },
    setCampoCargando: (state, action) => {
      const { idpk, cargando } = action.payload
      const campo = state.campos.find((c) => Number(c.idpk) === Number(idpk))
      campo.cargando = cargando
    },
    setCampoInicializando: (state, action) => {
      const { idpk, inicializando } = action.payload
      const campo = state.campos.find((c) => Number(c.idpk) === Number(idpk))
      campo.inicializando = inicializando
    },
    setCampoError: (state, action) => {
      const { idpk, error } = action.payload
      const campo = state.campos.find((c) => Number(c.idpk) === Number(idpk))
      campo.error = error
    },
    setCampoValidando: (state, action) => {
      const { idpk, validando } = action.payload
      const campo = state.campos.filter((c) => Number(c.idpk) === Number(idpk))[0]
      campo.validando = validando
    },
    addSolicitudALista: (state, action) => {
      const solicitud = action.payload
      if (
        !state.disponibles.filter(
          (s) => s?.tipo === solicitud?.tipo && s?.subtipo === solicitud?.subtipo,
        )
      ) {
        state.disponibles.push(solicitud)
      }
    },
    executeFieldAction: (state, action) => {
      const fieldAction = action.payload.action

      const campo = state.campos.find(
        (c) => c.codigo_campo === fieldAction.campo_destino.replace(':', ''),
      )

      const section = state.estructura.filter((b) => {
        for (let i = 0; i < b.campos.length; i++) {
          if (b.campos[i].idpk === campo.idpk) {
            return true
          }
        }
        return false
      })[0].campos

      const sectionField = section.filter((c) => c.idpk === campo.idpk)[0]

      switch (fieldAction.accion) {
        case 'VN':
          campo.visible = 'N'
          sectionField.visible = 'N'
          break
        case 'VS':
          campo.visible = 'S'
          sectionField.visible = 'S'
          break
        case 'OP':
          campo.obligatorio = 'N'
          break
        case 'OB':
          campo.obligatorio = 'S'
          break
        case 'BR':
          state.datos[campo.idpk] = null
          state.descripciones[campo.idpk] = null

          if (campo?.cmp_dependientes) {
            campo.cmp_dependientes
              .replace(/:/gm, '')
              .split(',')
              .forEach((codigo_campo) => {
                const dependiente = state.campos.filter((c) => c.codigo_campo === codigo_campo)[0]
                state.datos[dependiente.idpk] = null
              })
          }

          break

        default:
          break
      }
    },
    resetErrors: (state) => {
      state.campos.forEach((campo) => {
        campo.error = false
      })
    },
    resetSolicitud: (state, action) => {
      state.campos = []
      state.estructura = []
      state.datos = []
      state.descripciones = []
      state.datos_iniciales = []
      state.descripciones_iniciales = []
      state.html = ''
      state.modo = ''
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchListaSolicitudes.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchListaSolicitudes.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
      .addCase(fetchListaSolicitudes.fulfilled, (state, action) => {
        state.error = ''
        state.loading = false
        state.disponibles = action.payload
      })
      .addCase(fetchCamposSolicitudes.pending, (state) => {
        state.loadingCampos = true
      })
      .addCase(fetchCamposSolicitudes.rejected, (state, action) => {
        state.errorCampos = action.error.message
        state.loadingCampos = false
      })
      .addCase(fetchCamposSolicitudes.fulfilled, (state, action) => {
        state.errorCampos = ''
        state.loadingCampos = false

        const datos = {}
        const descripciones = {}
        const datos_iniciales = {}
        const descripciones_iniciales = {}
        action.payload.campos.forEach((c) => {
          if (c.tipo_dato !== 'S') {
            datos[c.idpk] = c.valor_dfto ?? null
            descripciones[c.idpk] = null
          }
          c.cargando = false
          c.inicializando = 'P'
          c.error = false
          c.lovVersion = 0
        })

        const estructura = []
        const separadores = action.payload.campos.filter(
          (c) => c.tipo_dato === 'S' && c.visible === 'S',
        )

        if (separadores.length === 0) {
          estructura.push({
            idpk: -1,
            campos: [],
          })
          action.payload.campos.forEach((c) => {
            estructura[0].campos.push({
              idpk: c.idpk,
              tipo_dato: c.tipo_dato,
              lv_codigo: c.lv_codigo,
              lv_tipo: c.lv_tipo,
              visible: c.visible,
            })
          })
        } else {
          //Insert all fields previous to the first divider
          const fields = []
          for (let i = 0; i < action.payload.campos.length; i++) {
            const field = action.payload.campos[i]
            if (field.tipo_dato === 'S') {
              break
            }
            fields.push({
              idpk: field.idpk,
              tipo_dato: field.tipo_dato,
              lv_codigo: field.lv_codigo,
              lv_tipo: field.lv_tipo,
              visible: field.visible,
            })
          }
          if (fields.length > 0) {
            estructura.push({
              idpk: null,
              campos: fields,
            })
          }

          separadores.forEach((s) => {
            const campos = []

            let iniciar = false
            for (let i = 0; i < action.payload.campos.length; i++) {
              const campo = action.payload.campos[i]
              if (iniciar && campo.tipo_dato === 'S' && campo.codigo_campo !== s.codigo_campo) {
                break
              }
              if (iniciar) {
                campos.push({
                  idpk: campo.idpk,
                  tipo_dato: campo.tipo_dato,
                  lv_codigo: campo.lv_codigo,
                  lv_tipo: campo.lv_tipo,
                  visible: campo.visible,
                })
              }
              if (campo.codigo_campo === s.codigo_campo) {
                iniciar = true
              }
            }
            estructura.push({
              idpk: s.idpk,
              campos: campos,
            })
          })
        }

        // Incluir campos huérfanos (bajo separadores no visibles) en una sección oculta
        const includedIdpks = new Set(estructura.flatMap((s) => s.campos.map((c) => c.idpk)))
        const orphaned = action.payload.campos.filter(
          (c) => c.tipo_dato !== 'S' && !includedIdpks.has(c.idpk),
        )
        if (orphaned.length > 0) {
          estructura.push({
            idpk: -2,
            campos: orphaned.map((c) => ({
              idpk: c.idpk,
              tipo_dato: c.tipo_dato,
              lv_codigo: c.lv_codigo,
              lv_tipo: c.lv_tipo,
              visible: c.visible,
            })),
          })
        }

        state.campos = action.payload.campos
        state.estructura = estructura
        state.html = action.payload.html || ''
        state.modo = action.payload.modo || ''
        state.datos = datos
        state.descripciones = descripciones
        state.datos_iniciales = datos_iniciales
        state.descripciones_iniciales = descripciones_iniciales
      })
      .addCase(consultaInicial.pending, (state, action) => {
        state.loading = true

        const idpk = action.meta.arg.idpk

        action.payload = {
          idpk,
          cargando: true,
        }
        solicitudesSlice.caseReducers.setCampoCargando(state, action)

        action.payload = {
          idpk,
          inicializando: 'R',
        }
        solicitudesSlice.caseReducers.setCampoInicializando(state, action)
      })
      .addCase(consultaInicial.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false

        const idpk = action.meta.arg.idpk

        action.payload = {
          idpk,
          cargando: false,
        }
        solicitudesSlice.caseReducers.setCampoCargando(state, action)

        action.payload = {
          idpk,
          inicializando: 'E',
        }
        solicitudesSlice.caseReducers.setCampoInicializando(state, action)
      })
      .addCase(consultaInicial.fulfilled, (state, action) => {
        state.error = ''
        state.loading = false

        const idpk = action.payload.idpk
        const tipo = state.campos.filter((c) => Number(c.idpk) === Number(idpk))[0].tipo_dato
        const mascara_formato = state.campos.filter((c) => Number(c.idpk) === Number(idpk))[0]
          .mascara_formato

        const valor =
          tipo === 'D' || tipo === 'DH1' || tipo === 'DH2'
            ? dayjs(action.payload.valor, mascara_formato)
            : action.payload.valor
        action.payload.valor = valor
        if (!action.payload.descripcion) action.payload.descripcion = null

        state.datos_iniciales[idpk] = valor
        state.descripciones_iniciales[idpk] = !action.payload.descripcion
          ? null
          : action.payload.descripcion

        solicitudesSlice.caseReducers.setDatoSolicitud(state, action)

        action.payload = {
          idpk,
          cargando: false,
        }
        solicitudesSlice.caseReducers.setCampoCargando(state, action)

        action.payload = {
          idpk,
          inicializando: 'Z',
        }
        solicitudesSlice.caseReducers.setCampoInicializando(state, action)
      })
      .addCase(inicializaSolicitud.pending, (state) => {
        state.loadingInicializacion = true
        state.errorInicializacion = ''

        // Marcar todos los campos que necesitan inicialización como cargando
        state.campos.forEach((campo) => {
          if (campo.inicializar) {
            campo.cargando = true
            campo.inicializando = 'R'
          }
        })
      })
      .addCase(inicializaSolicitud.rejected, (state, action) => {
        state.loadingInicializacion = false
        state.errorInicializacion = action.error.message

        // Marcar todos los campos con error
        state.campos.forEach((campo) => {
          if (campo.inicializar) {
            campo.cargando = false
            campo.inicializando = 'E'
          }
        })
      })
      .addCase(inicializaSolicitud.fulfilled, (state, action) => {
        state.loadingInicializacion = false
        state.errorInicializacion = ''

        // Procesar cada valor recibido
        const valoresIniciales = action.payload || []
        valoresIniciales.forEach((item) => {
          const idpk = item.idpk
          const campo = state.campos.find((c) => Number(c.idpk) === Number(idpk))

          if (campo) {
            const tipo = campo.tipo_dato
            const mascara_formato = campo.mascara_formato

            // Convertir valor si es fecha
            const valor =
              tipo === 'D' || tipo === 'DH1' || tipo === 'DH2'
                ? dayjs(item.valor, mascara_formato)
                : item.valor

            // Guardar en datos y datos_iniciales
            state.datos[idpk] = valor
            state.descripciones[idpk] = item.descripcion || null
            state.datos_iniciales[idpk] = valor
            state.descripciones_iniciales[idpk] = item.descripcion || null

            // Marcar campo como inicializado
            campo.cargando = false
            campo.inicializando = 'Z'
          }
        })

        // Marcar campos que necesitaban inicialización pero no recibieron valor
        state.campos.forEach((campo) => {
          if (campo.inicializar && campo.inicializando === 'R') {
            campo.cargando = false
            campo.inicializando = 'Z'
          }
        })
      })
  },
})

export const {
  setSolicitudSeleccionada,
  setDatoSolicitud,
  setDatosSolicitud,
  setDatosVacaciones,
  setCampoCargando,
  setCampoInicializando,
  setCampoError,
  setCampoValidando,
  addSolicitudALista,
  resetErrors,
  resetSolicitud,
  executeFieldAction,
  loadDatosEditando,
} = solicitudesSlice.actions

export const selectListaSolicitudesStatus = (state) => state.solicitudes.loading
export const selectListaSolicitudesError = (state) => state.solicitudes.error
export const selectListaSolicitudesDisponibles = (state) => state.solicitudes.disponibles
export const selectSolicitudSeleccionada = (state) => state.solicitudes.seleccionada
export const selectCamposStatus = (state) => state.solicitudes.loadingCampos
export const selectCamposError = (state) => state.solicitudes.errorCampos
export const selectInicializacionStatus = (state) => state.solicitudes.loadingInicializacion
export const selectInicializacionError = (state) => state.solicitudes.errorInicializacion
export const selectCamposSolicitud = (state) => state.solicitudes.campos
export const selectEstructuraSolicitud = (state) => state.solicitudes.estructura
export const selectDatosSolicitud = (state) => state.solicitudes.datos
export const selectDescripcionesSolicitud = (state) => state.solicitudes.descripciones
export const selectDatosInicialesSolicitud = (state) => state.solicitudes.datos_iniciales
export const selectHtmlSolicitud = (state) => state.solicitudes.html
export const selectModoSolicitud = (state) => state.solicitudes.modo
export const selectVacionesPendientes = (state) => state.solicitudes.vacaciones.pendientes
export const selectVacionesTipoDias = (state) => state.solicitudes.vacaciones.tipo_dias
export const selectVacacionesDisfrutaHoras = (state) => state.solicitudes.vacaciones.disfruta_horas
export const selectVacaciones = (state) => state.solicitudes.vacaciones

export default solicitudesSlice.reducer
